/**
 * Hides filter values that have no purchasable stock.
 *
 * Shopify counts a variant metafield filter value (e.g. Size) by how many products
 * *define* that value, ignoring whether those variants are in stock. That is why the
 * size filter lists every size the collection has ever carried instead of the ones a
 * customer can actually buy right now.
 *
 * Shopify does compute stock-aware counts when `filter.v.availability=1` is present, so
 * this script asks the existing `view=filters` JSON template for the stock-aware value
 * list and hides everything missing from it. Results are untouched: only the option list
 * is trimmed.
 *
 * Progressive enhancement. If the request fails the filters keep their current behaviour.
 */
(function () {
  if (window.__facetsStockInit) return;
  window.__facetsStockInit = true;

  var AVAILABILITY_PARAM = 'filter.v.availability';
  var HIDDEN_ATTR = 'data-facet-out-of-stock';

  function collectAllowedValues(data) {
    var allowed = {};

    (data.filters || []).forEach(function (filter) {
      (filter.values || []).forEach(function (value) {
        var param = (value.param_name || '').trim();
        if (!param) return;
        if (!allowed[param]) allowed[param] = [];
        allowed[param].push(String(value.label).trim());
      });
    });

    return allowed;
  }

  function prune(allowed) {
    var inputs = document.querySelectorAll('form[is="facets-form"] input.dot-checkbox');

    Array.prototype.forEach.call(inputs, function (input) {
      // A filter absent from the stock-aware response has no in-stock values at all.
      // Leave it alone rather than emptying the whole group.
      var permitted = allowed[input.name];
      if (!permitted) return;

      // Never hide what the customer has already selected, or they lose the way to undo it.
      if (input.checked) return;

      var row = input.closest('.checkbox-control');
      if (!row || row.hasAttribute(HIDDEN_ATTR)) return;

      var label = row.querySelector('label');
      var text = label ? label.textContent.trim() : String(input.value).trim();

      if (permitted.indexOf(text) === -1) {
        row.hidden = true;
        row.setAttribute(HIDDEN_ATTR, '');
      }
    });
  }

  function refresh() {
    if (!document.querySelector('form[is="facets-form"]')) return;

    var params = new URLSearchParams(window.location.search);

    // Already browsing in stock-only mode: Shopify's own counts are correct here.
    if (params.get(AVAILABILITY_PARAM) === '1') return;

    params.set(AVAILABILITY_PARAM, '1');
    params.set('view', 'filters');

    fetch(window.location.pathname + '?' + params.toString())
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        if (data && Array.isArray(data.filters)) prune(collectAllowedValues(data));
      })
      .catch(function () {
        /* Filters stay as Shopify rendered them. */
      });
  }

  function watchForRerenders() {
    // Applying a facet re-renders the whole section: the theme swaps in nodes parsed by
    // DOMParser, which browsers mark as already-executed, so this file never runs again on
    // its own. The listener lives on `document`, which survives that swap, and re-runs once
    // the replacement has settled.
    //
    // Most paths need no work: the theme forces `filter.v.availability=1` into the URL as
    // soon as any facet is applied, and Shopify's own counts are stock-aware from then on
    // (refresh() returns early in that case). The path that does need this is clearing the
    // filters, which drops the availability param and brings the sold-out values back.
    var pending;

    document.addEventListener('facet:update', function () {
      clearTimeout(pending);
      pending = setTimeout(refresh, 150);
    });

    // facet:update fires before the new section arrives, so when the fetch is slow the pass
    // above trims the old nodes and the replacement lands untouched. facet:rendered fires
    // once the replacement is in the DOM.
    document.addEventListener('facet:rendered', function () {
      clearTimeout(pending);
      pending = setTimeout(refresh, 0);
    });
  }

  function init() {
    refresh();
    watchForRerenders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
